import CIMSFormItem from 'components/CIMSFormItem'
import CIMSSelect from 'components/CIMSSelect'
import { useOptions } from 'components/CIMSSelect/hooks/useOptions'
import type {
  NotificationField,
  NotificationStatus,
} from '../../../../../types'
import { useStatusOptions } from '../../../hooks/useStatusOptions'
import { createNotificationSystemStateReference } from '../../../utils/referenceValues'
import FieldChangeSettingsField from './FieldChangeSettingsField'

type TransitionSettingsProps = {
  fields: NotificationField[]
  statuses: NotificationStatus[]
  trigger: 'advanced' | 'reverted'
}

/** Edits optional source and destination restrictions for a lifecycle trigger. */
function TransitionSettings({
  fields,
  statuses,
  trigger,
}: TransitionSettingsProps) {
  const statusOptions = useStatusOptions(statuses)
  const noPreviousStatusOptions = useOptions({
    items: [createNotificationSystemStateReference('create')],
    label: 'label',
    sort: false,
    tooltip: 'tooltip',
    value: 'value',
  })
  const draftOption = createNotificationSystemStateReference('draft')
  const closedOption = createNotificationSystemStateReference('closed')
  const fromOptions =
    trigger === 'advanced'
      ? [...noPreviousStatusOptions, draftOption, ...statusOptions]
      : [...statusOptions, closedOption]
  const toOptions =
    trigger === 'advanced'
      ? [...statusOptions, closedOption]
      : [draftOption, ...statusOptions]

  return (
    <>
      <CIMSFormItem
        label="From any of these statuses"
        name={['drafts', trigger, 'from']}
      >
        <CIMSSelect
          mode="multiple"
          options={fromOptions}
          placeholder="Any status"
        />
      </CIMSFormItem>
      <CIMSFormItem
        label="To any of these statuses"
        name={['drafts', trigger, 'to']}
      >
        <CIMSSelect
          mode="multiple"
          options={toOptions}
          placeholder="Any status"
        />
      </CIMSFormItem>
      <FieldChangeSettingsField
        fields={fields}
        name={['drafts', trigger, 'useAdvancedSettings']}
      />
    </>
  )
}

export default TransitionSettings
